import { Component, ElementRef, HostListener, Input, OnInit } from '@angular/core';
import { UserSessionService } from 'bna-angular-auth-client';
import { environment } from 'src/environments/environment';
import {querySelectorAllDeep,querySelectorDeep} from "query-selector-shadow-dom";
import { NavigationEnd, Router } from '@angular/router';
import { AlexService } from 'src/app/core/services/http/maintenance/alex.service';
import { AlexFeedbackModel } from 'src/app/settings/models/alex.model';

declare var Intercom: any;

@Component({
  selector: 'app-alex',
  templateUrl: './alex.component.html',
  styleUrls: ['./alex.component.scss'],
})
export class AlexComponent implements OnInit {
  @Input() set isShowChat(value: boolean) {
    if (!value)
      return;
    this.connectToAlexGeminiModels();
  }

  isAlexChatBotAllowed = true;
  isPopupOpen = false;
  feedbackText = '';
  agentResponses: HTMLDivElement = null;
  isKeepAsAlexChatOpen = false;

  readonly agentId = `${environment.alexAgent.agentId}`;
  readonly projectId = `${environment.alexAgent.projectId}`;

  constructor(
    public userSessionService: UserSessionService,
    private elementRef: ElementRef,
    private router: Router,
    private alexService: AlexService
  ) {
      this.router.events.subscribe((event: any) => {
        if (event instanceof NavigationEnd) {
          if (event.url.includes('inspection-manager')) {
            this.isAlexChatBotAllowed = false;
          } else {
            this.isAlexChatBotAllowed = true;
          }
        }
      });
  }

  ngOnInit(): void {
    this.setupDialogflowEventListeners();
    this.userSessionService.isAuthenticated$.subscribe((result) => {
      console.log('isAuthenticated', result.isAuthenticated);
      if (!result.isAuthenticated) {
        const dfMessenger = document.querySelector('df-messenger') as any;
        if (dfMessenger) {
          dfMessenger.startNewSession({ retainHistory: false });
        }
        return;
      }
    });

    window.addEventListener('df-messenger-error', (event) => {
      const dfMessenger = document.querySelector('df-messenger') as any;
      dfMessenger.renderCustomText('<p  class="error-message">Our system is handling a high volume of requests. Please try again in a moment.</p>', true);
      setTimeout(() => {
        this.setErrorMsgStyles();
      }, 100);
    });
  }

  private connectToAlexGeminiModels() {

    const dfMessenger = document.querySelector('df-messenger') as any;

  if (sessionStorage.getItem('df-messenger-queryParameters') == null)
      dfMessenger.sendQuery('hi');

      const queryParameters = {
       parameters: {
         organizationId: this.userSessionService.getProfile().organizationId,
         userId: this.userSessionService.getProfile().id
       },
    };
    dfMessenger.setQueryParameters(queryParameters);
    
  }
  

  @HostListener('document:click', ['$event'])
  onClickOutside(event: Event) {
    const chatbotElement = this.elementRef.nativeElement.querySelector('.chatbot-container');
    const popupElement = this.elementRef.nativeElement.querySelector('.popup-overlay');
    // if (chatbotElement && !chatbotElement.contains(event.target as Node) && !this.isKeepAsAlexChatOpen && !popupElement) {
    //   const dfMessengerBubble = document.querySelector('df-messenger-chat-bubble') as any;
    //   dfMessengerBubble.closeChat();
    // }
    if(!popupElement && this.isKeepAsAlexChatOpen && !this.isPopupOpen){
      this.isKeepAsAlexChatOpen = false;
    }

    var ele = event.target as Element;
    if(ele && ele.nodeName.includes("DF-MESSENGER-CHAT-BUBBLE")){
      this.feedbackStyle();
    }
    
  }

  private setupDialogflowEventListeners() {
    document.addEventListener('df-messenger-loaded', () => {
      setTimeout(() => {
        this.customizeChatbotUI();
      }, 500);
    });

    document.addEventListener('df-response-received', () => {
      setTimeout(() => {
        this.customizeChatbotUI();
      }, 250);
    });

  }

  customizeChatbotUI() {
    // const sendBtn = querySelectorDeep('#send-icon-button.active #send-icon');

    const message = querySelectorAllDeep('.message');
    if (message.length > 0) {
      message.forEach((msg) => {
        msg.style.setProperty('cursor', 'text');
        msg.style.setProperty('user-select', 'text');
      });
    }

    const messageListWrapper = querySelectorDeep('.message-list-wrapper');
    messageListWrapper.style.backgroundColor = '#fff';

    const titlebarWrapper = querySelectorDeep('#titlebar-title');
    titlebarWrapper.style.flexDirection = 'row-reverse !important';
    titlebarWrapper.style.backgroundColor = '#000';

    const titleText = querySelectorDeep('#titlebar-title .title-text');
    titleText.style.flexGrow = '0 !important';

    const titleImg = querySelectorDeep('#titlebar-title img');
    titleImg.style.marginRight = 'auto !important';

    const msgImgs = querySelectorAllDeep('.message ul img');
    if (msgImgs.length > 0) {
      msgImgs.forEach((img) => {
        img.style.setProperty('max-width', '150px', 'important');
        img.style.setProperty('max-height', '150px', 'important');
      });
    }

    const msgLis = querySelectorAllDeep('.message li');
    if (msgLis.length > 0) {
      msgLis.forEach((li) => {
        li.style.setProperty('color', '#3578FF', 'important');
      });
    }

    const strongText = querySelectorAllDeep('strong');
    if (strongText.length > 0) {
      strongText.forEach((label) => {
        label.style.setProperty('font-weight', '600');
      });
    }

    const table = querySelectorAllDeep('.message table');
    if (table.length > 0) {
      table.forEach((table) => {
        table.style.display = 'block';
        table.style.width = '100%';
        table.style.overflowX = 'auto';
        table.style.borderCollapse = 'collapse';
        table.style.marginBottom = '5px';
        table.style.marginBottom = '5px';

        table.style.scrollbarWidth = 'thin';
        table.style.scrollbarColor = 'rgba(0, 0, 0, 0.1) #ffff ';

        table.style.setProperty('--webkit-scrollbar-width', '8px');
        table.style.setProperty('--webkit-scrollbar-height', '8px');
        table.style.setProperty(
          '--webkit-scrollbar-thumb',
          'rgba(0, 0, 0, 0.1)'
        );
        table.style.setProperty('--webkit-scrollbar-track', '#ffff');
      });
    }

    const messageList = querySelectorDeep('#message-list');
    messageList.style.scrollbarWidth = 'thin';
    messageList.style.scrollbarColor = 'rgba(0, 0, 0, 0.1) #ffff ';

    messageList.style.setProperty('--webkit-scrollbar-width', '8px');
    messageList.style.setProperty('--webkit-scrollbar-height', '8px');
    messageList.style.setProperty('--webkit-scrollbar-thumb', 'rgba(0, 0, 0, 0.1)');
    messageList.style.setProperty('--webkit-scrollbar-track', '#ffff');

    const th = querySelectorAllDeep('.message table thead th');
    if (th.length > 0) {
      th.forEach((th) => {
        th.style.minWidth = '150px';
        th.style.maxWidth = '300px';
      });
    }

    const td = querySelectorAllDeep('.message table tbody td');
    if (td.length > 0) {
      td.forEach((td) => {
        td.style.minWidth = '150px';
        td.style.maxWidth = '300px';
        td.style.backgroundColor = '#fff';
      });
    }

    const tableImgs = querySelectorAllDeep('.message table tbody img');
    if (tableImgs.length > 0) {
      tableImgs.forEach((tableImg) => {
        tableImg.style.setProperty('max-width', '50px', 'important');
        tableImg.style.setProperty('max-height', '50px', 'important');
        tableImg.style.setProperty('border-radius', '5px', 'important');
      });
    }

    // const linkList  =  querySelectorAllDeep('.dflink');
    // if (linkList.length > 0 ) {
    //   linkList.forEach((a) => {
    //     let route = a.getAttribute('href');
    //     a.setAttribute('href', '#');
    //     a.addEventListener(
    //       'click',
    //       (event) => this.handleRoute(event, route),
    //       false
    //     );
    //   });
    // }

    const inputBox = querySelectorAllDeep('.input-element-wrapper');
    if (inputBox.length > 0) {
      inputBox.forEach((th) => {
        th.style.setProperty('padding-right', '30px', 'important');
      });
    }

    // job details attachments style
    const detailsColumns = querySelectorAllDeep('.details-column');
    if (detailsColumns.length > 0) {
      detailsColumns.forEach((column) => {
        column.style.setProperty('background', '#fff');
        column.style.setProperty('padding', '10px 0px 10px 6px');
      });
    }

    // popup the intercom help tab
    const openIntercomHelp  =  querySelectorAllDeep('.openIntercomHelpBtnId');
    debugger;
    if (openIntercomHelp.length > 0 ) {
      openIntercomHelp.forEach((a) => {
        a.addEventListener(
          'click',
          (event) => this.openIntercomHelp(),
          false
        );
      });
    }

    const attachments = querySelectorAllDeep('.details-column .attachments');
    if (attachments.length > 0) {
      attachments.forEach((attachment) => {
        const parentColumn = attachment.closest('.details-column');
        attachment.style.setProperty('display', 'grid');
        attachment.style.setProperty('grid-template-columns', '1fr 1fr');
        if (parentColumn) {
          parentColumn.style.setProperty('display', 'grid');
        }
      });
    }

    attachments.forEach((block) => {
      const images = Array.from(block.querySelectorAll('img'));

      if (images.length > 0) {
        const spacer = document.createElement('div');
        spacer.style.gridColumn = '1 / -1';
        spacer.style.height = '1px';
        block.appendChild(spacer);
      }

      images.forEach((img) => {
        block.appendChild(img);
      });
    });

    const img = querySelectorAllDeep('.details-column .attachments img');
    if (img.length > 0) {
      img.forEach((img) => {
        img.style.setProperty('height', '200px');
        img.style.setProperty('width', '200px');
        img.style.setProperty('margin', '5px');
        img.style.setProperty('object-fit', 'contain');
        img.style.setProperty('padding', '2px');
        img.style.setProperty('background', '#eff3f6');
        img.style.setProperty('cursor', 'default');
      });
    }

    const a = querySelectorAllDeep('.details-column .attachments a');
    if (a.length > 0) {
      a.forEach((a) => {
        a.style.setProperty('margin', '5px');
        a.style.setProperty('width', '186px', 'important');
        a.style.setProperty('white-space', 'nowrap');
        a.style.setProperty('overflow', 'hidden');
        a.style.setProperty('text-overflow', 'ellipsis');

         a.setAttribute('target', '_blank');
      });
    }

    const link = querySelectorAllDeep('.details-column .dflink');
    if (link.length > 0) {
      link.forEach((link) => {
        if (!link.closest('.attachments')) {
          link.style.setProperty('padding', '0px');
          link.style.setProperty('border', 'none');
          link.style.setProperty('text-decoration', 'underline');
        }
      });
    }

    // job details styles
    const jobCard = querySelectorAllDeep('.job-card');
    if (jobCard.length > 0) {
      jobCard.forEach((p) => {
        p.style.setProperty('background-color', '#fff');
        p.style.setProperty('padding', '15px 25px');
        p.style.setProperty('margin-bottom', '8px');
        p.style.setProperty('border-radius', '5px');
        p.style.setProperty('min-width', '420px');

        const jobHeader = p.querySelector('.job-header');
        if (jobHeader) {
          jobHeader.style.setProperty('display', 'flex');
          jobHeader.style.setProperty('justify-content', 'space-between');
          jobHeader.style.setProperty('align-items', 'center');
          jobHeader.style.setProperty('margin-bottom', '16px');
        }

        const jobNumber = p.querySelector('.job-number');
        if (jobNumber) {
          jobNumber.style.setProperty('display', 'flex');
          jobNumber.style.setProperty('width', '30%');
        }

        const tags = p.querySelector('.tags');
        if (tags) {
          tags.style.setProperty('display', 'flex');
          tags.style.setProperty('gap', '8px');
        }

        const statusElements = p.querySelectorAll('.status');
        if (statusElements.length > 0) {
          statusElements.forEach((status) => {
            status.style.setProperty('font-size', '12px');
            status.style.setProperty('padding', '5px 10px');
            status.style.setProperty('border-radius', '3px');
          });
        }

        const jobType = p.querySelector('.job-type');
        if (jobType) {
          jobType.style.setProperty('color', '#e1ac5b');
          jobType.style.setProperty('background-color', '#fcf3ce');
        }

        const urgencyTag = p.querySelector('.urgency-tag');
        if (urgencyTag) {
          urgencyTag.style.setProperty('color', '#fc573b');
          urgencyTag.style.setProperty('background-color', '#ffe6e2');
        }

        const jobBody = p.querySelector('.job-body');
        if (jobBody) {
          jobBody.style.setProperty('line-height', '18px');
        }

        const paragraphs = p.querySelectorAll('p');
        if (paragraphs.length > 0) {
          paragraphs.forEach((paragraph) => {
            paragraph.style.setProperty('margin', '0px 0px 10px 0px');
            paragraph.style.setProperty('font-size', '12px');
          });
        }

        const title = p.querySelector('.title');
        if (title) {
          title.style.setProperty('font-size', '14px');
          title.style.setProperty('font-weight', '600');
          title.style.setProperty('margin-bottom', '10px');
          title.style.setProperty('margin', '0px 0px 8px');
        }

        const description = p.querySelector('.description');
        if (description) {
          description.style.setProperty('margin', '0px 0px 10px 0px');
        }

        const detailsColumns = p.querySelectorAll('.details-column');
        if (detailsColumns.length > 0) {
          detailsColumns.forEach((column) => {
            column.style.setProperty('display', 'flex');
            column.style.setProperty('gap', '12px');
            column.style.setProperty('margin-bottom', '10px');
            column.style.setProperty('width', '100%');
            column.style.setProperty('flex-wrap', 'wrap');
            column.style.setProperty('padding', '0px');
          });
        }

        const detailsColumnParagraphs = p.querySelectorAll('.details-column p');
        if (detailsColumnParagraphs.length > 0) {
          detailsColumnParagraphs.forEach((paragraph) => {
            const strongTag = paragraph.querySelector('strong');

            paragraph.style.setProperty('flex', 'none');
            paragraph.style.setProperty('width', '48%');
            paragraph.style.setProperty('margin', '0px');

            if (strongTag && strongTag.textContent.trim() === "Address") {
              paragraph.style.setProperty('width', '100%');
            }
          });
        }
      });
    }
    
    // job activities styles
    const activityCard = querySelectorAllDeep('.activity-card');
    if (activityCard.length > 0) {
      activityCard.forEach((p) => {
        p.style.setProperty('background-color', '#fff');
        p.style.setProperty('padding', '15px 15px 15px 40px');
        p.style.setProperty('width', '300px');
        p.style.setProperty('margin-bottom', '1px');

        const para = p.querySelectorAll('.activity-details p');
        if (para) {
          para.forEach((par) => {
            par.style.setProperty('margin', '0', 'important');
            par.style.setProperty('font-size', '12px');
          });
        }
      });
    }

    const activityTitles = querySelectorAllDeep('.activity-title p');

    activityTitles.forEach((pElement) => {
      pElement.style.setProperty('display', 'flex');
      pElement.style.setProperty('align-items', 'center');
      pElement.style.setProperty('margin-bottom', '3px');
      const text = pElement.textContent?.trim().toLowerCase();
      let imgSrc = '/assets/images/Alex/doc.svg';

      if (text?.includes('job')) {
        imgSrc = '/assets/images/Alex/work.svg';
      } else if (text?.includes('email')) {
        imgSrc = '/assets/images/Alex/mail.svg';
      }

      const imgElement = document.createElement('img');
      imgElement.src = imgSrc;
      imgElement.alt = text || 'icon';
      imgElement.style.height = '14px';
      imgElement.style.marginRight = '5px';
      imgElement.style.marginLeft = '-30px';
      imgElement.style.marginBottom = '0px';
      imgElement.style.background = '#eff3f6';
      imgElement.style.padding = '5px';
      imgElement.style.borderRadius = '50%';

      if (!pElement.querySelector('img')) {
        pElement.prepend(imgElement);
      }
    });

    // property managers list

    const propertyManagers = querySelectorAllDeep('.property-managers');
    if (propertyManagers.length > 0) {
      propertyManagers.forEach((list) => {
        list.style.setProperty('background-color', '#fff');
        list.style.setProperty('padding', '10px 0px 10px 0px');

        const li = list.querySelectorAll('li');
        if (li) {
          li.forEach((li) => {
            li.style.setProperty('color', '#000', 'important');
            // li.style.setProperty('font-size', '12px');
          });
        }
        
        const a = list.querySelectorAll('li a');
        if (a) {
          a.forEach((a) => {
            a.style.setProperty('font-size', '12px');
            a.style.setProperty('padding', '0px');
            a.style.setProperty('border', 'none');
            a.style.setProperty('text-decoration', 'underline');
          });
        } 
      });
    }

   // this.addFeedBackIcons();
   const feedback = querySelectorAllDeep('button.thumb.focus-outline > svg');
   if (feedback.length > 0) {
     feedback.forEach((lable) => {
       lable.setAttribute('width', '16px');
       lable.setAttribute('height', '16px');
     });
   }

   const test = querySelectorAllDeep('.feedback');
   if (test.length > 0) {
     test.forEach((lable) => {
       lable.style.setProperty('margin-top', '5px', 'important');
     });
   }

   const thumbBtn = querySelectorAllDeep('.thumb');
   if (thumbBtn.length > 0) {
     thumbBtn.forEach((thumbBtn) => {
       thumbBtn.style.setProperty('height', '34px');
       thumbBtn.style.setProperty('margin-right', '3px');
       thumbBtn.style.setProperty('cursor', 'pointer');
     });
   }

   const button = querySelectorAllDeep('button');
   if (button.length > 0) {
     button.forEach((button) => {
       button.style.setProperty('cursor', 'pointer');
     });
   }

   const navButton = querySelectorAllDeep('.nav-button');
   if (navButton.length > 0) {
     navButton.forEach((btn) => {
       btn.style.setProperty('cursor', 'pointer');
       btn.style.setProperty('color', '#3D3D3D');
       btn.style.setProperty('border-color', '#CDE1FD');
       btn.style.setProperty('background', '#fff');
       btn.style.setProperty('padding', '6px 10px');
       btn.style.setProperty('border-radius', '4px');
     });
   }

   navButton.forEach((button) => {
     const parentP = button.closest('p');

     if (parentP && !parentP.closest('.invoice-details')) {
       parentP.style.lineHeight = '2.2';
     }
   });

   const navPathItems = querySelectorAllDeep('.nav-path li');

   if (navPathItems.length > 0) {
     navPathItems.forEach((li) => {
       li.style.setProperty('margin-left', '-20px');
     });
   }

   const invoiceDetails = querySelectorAllDeep('.invoice-details');
   invoiceDetails.forEach((invoiceDetails) => {
     invoiceDetails.style.setProperty('padding', '15px');
     invoiceDetails.style.setProperty('background-color', '#fff');
     invoiceDetails.style.setProperty('border-radius', '5px');
   });

   const invoiceItems = querySelectorAllDeep('.invoice-details p');
   invoiceItems.forEach((det) => {
     det.style.setProperty('display', 'flex');
   });

   const labels = querySelectorAllDeep('.invoice-details p strong');
   labels.forEach((label) => {
     label.style.setProperty('min-width', '150px');
     label.style.setProperty('display', 'flex');
   });

   this.feedbackStyle();
   // this.addFeedBackIcons();
 }

 feedbackStyle() {
   const feedback = querySelectorAllDeep('button.thumb.focus-outline > svg');
   if (feedback.length > 0) {
     feedback.forEach((lable) => {
       lable.setAttribute('width', '16px');
       lable.setAttribute('height', '16px');
     });
   }

   const test = querySelectorAllDeep('.feedback');
   if (test.length > 0) {
     test.forEach((lable) => {
       lable.style.setProperty('margin-top', '5px', 'important');
     });
   }

   const feedbackTitle = querySelectorAllDeep('.feedback-title');
   if (feedbackTitle.length > 0) {
     feedbackTitle.forEach((feedbackTitle) => {
       feedbackTitle.style.setProperty('font-weight', '600', 'important');
     });
   }

   const button = querySelectorAllDeep('.feedback-box button');
   if (button.length > 0) {
     button.forEach((button) => {
         button.style.setProperty('cursor', 'pointer');
     });
   }

   const submitButtons = querySelectorAllDeep('.feedback-submit');
   submitButtons.forEach((submitBtn) => {
     submitBtn.addEventListener('mouseenter', () => {
       submitBtn.style.setProperty('background', '#755DF9');
       submitBtn.style.setProperty('color', '#fff');
     });
   });

   const noticeRow = querySelectorAllDeep('.privacy-notice-row ');
   noticeRow.forEach((noticeRow) => {
     noticeRow.style.setProperty('padding', '0px 3px');
   });

   const feedBacktextarea = querySelectorAllDeep('.feedback-box .textarea-row textarea');
   if (feedBacktextarea.length > 0) {
     feedBacktextarea.forEach((t) => {
       t.setAttribute('rows', '2');
     });
   }

   const feedbackClose = querySelectorAllDeep('.feedback-close svg');
   if (feedbackClose.length > 0) {
     feedbackClose.forEach((icon) => {
       icon.setAttribute('width', '16px');
       icon.setAttribute('height', '16px');
     });
   }
 }
  

  handleRoute(event,route){
    event.preventDefault();
    this.router.navigate([route]);
  }

  setErrorMsgStyles(){
    const errorMsg = querySelectorAllDeep('.error-message');
    if (errorMsg.length > 0) {
      errorMsg.forEach((msg) => {
        msg.parentElement.style.setProperty('background', '#FFF6F5', 'important');
        msg.parentElement.style.setProperty('border-color', '#FC573B', 'important');
        msg.style.setProperty('color', '#FC573B', 'important');
      });
    }
  }

  addFeedBackIcons(){
    querySelectorAllDeep(".feedback-icons").forEach((icon) => icon.remove());
    const agentMsg = querySelectorAllDeep('.bot-message');
    agentMsg.forEach((message) => {
      let feedbackIcons = document.createElement("div");
      feedbackIcons.classList.add("feedback-icons");
      feedbackIcons.style.setProperty('padding', '5px');

      let thumbsUp = document.createElement("span");
      thumbsUp.style.setProperty('padding-right', '8px');
      thumbsUp.style.setProperty('cursor', 'pointer');
      thumbsUp.style.setProperty('opacity', '0.5');

      thumbsUp.addEventListener('mouseenter', () => {
        thumbsUp.style.setProperty('opacity', '0.8');
      });
      
      thumbsUp.addEventListener('mouseleave', () => {
        if (!thumbsUp.classList.contains('active')) {
          thumbsUp.style.setProperty('opacity', '0.5');
        }
      });
      thumbsUp.innerHTML = `<img src="/assets/images/Alex/thumb_up_mat.svg" alt="Thumbs Up" width="16">`;
      const imgElement1 = thumbsUp.querySelector('img') as HTMLImageElement;
  
      let thumbsDown = document.createElement("span");
      thumbsDown.style.setProperty('padding-right', '8px');
      thumbsDown.style.setProperty('cursor', 'pointer');
      thumbsDown.style.setProperty('opacity', '0.5');

      thumbsDown.addEventListener('mouseenter', () => {
        thumbsDown.style.setProperty('opacity', '0.8');
      });

      thumbsDown.addEventListener('mouseleave', () => {
        if (!thumbsDown.classList.contains('active')) {
          thumbsDown.style.setProperty('opacity', '0.5');
        }
      });

      thumbsDown.innerHTML = `<img src="/assets/images/Alex/thumb_down_mat.svg" alt="Thumbs Down" width="16">`;
      const imgElement2 = thumbsDown.querySelector('img') as HTMLImageElement;

      thumbsUp.addEventListener('click', () => {
        
        if (imgElement1) {
          imgElement2.src = '/assets/images/Alex/thumb_down_mat.svg';
          imgElement1.src = '/assets/images/Alex/thumb_up_active.svg';

          imgElement1.style.setProperty('transform', 'scale(1.5)');
          imgElement1.style.setProperty(
            'transition',
            'transform 0.3s ease-in-out'
          );

          setTimeout(() => {
            imgElement1.style.setProperty('transform', 'scale(1)');
          }, 200);
        }
        thumbsUp.style.setProperty('opacity', '1');
        thumbsUp.classList.add('active');
        thumbsDown.style.setProperty('opacity', '0.5');
        thumbsDown.classList.remove('active');
        this.thumbsUpClick(message);
      });

      thumbsDown.addEventListener('click', () => {

        if (imgElement2) {
          imgElement1.src = '/assets/images/Alex/thumb_up_mat.svg';
          imgElement2.src = '/assets/images/Alex/thumb_down_active.svg';
          imgElement2.style.setProperty('transform', 'scale(1.5)');
          imgElement2.style.setProperty(
            'transition',
            'transform 0.2s ease-in-out'
          );
          setTimeout(() => {
            imgElement2.style.setProperty('transform', 'scale(1)');
          }, 200);
        }
        
        thumbsDown.style.setProperty('opacity', '0.9');
        thumbsDown.classList.add('active');
        thumbsUp.style.setProperty('opacity', '0.5');
        thumbsUp.classList.remove('active');
        this.thumbsDownClick(message);
      });
  
 
      feedbackIcons.appendChild(thumbsUp);
      feedbackIcons.appendChild(thumbsDown);
  
      message.insertAdjacentElement("afterend", feedbackIcons);
    });
  }

  
  private thumbsUpClick(message: HTMLDivElement) {
    this.addUserFeedback(message, true);
  }
 
  private addUserFeedback(message: HTMLDivElement, isPositive: boolean, addedfeedback: string = null) {
    const messageClone = document.createElement('div');
    messageClone.innerHTML = message.innerHTML;
 
    const pElement = messageClone.querySelector('p');
 
    const feedback = new AlexFeedbackModel();
    feedback.sessionId = sessionStorage.getItem('df-messenger-sessionID');
    feedback.agentResponseMsg = pElement ? pElement.innerHTML : messageClone.innerHTML;
    feedback.feedback = addedfeedback;
    feedback.isPositive = isPositive;
 
    this.alexService.addFeedback(feedback).subscribe({
      next: () => {
        console.log('Feedback added successfully');
      },
      error: () => {
        console.log('Error while adding feedback');
      },
    });
  }
 
  private thumbsDownClick(message: HTMLDivElement) {
    this.isPopupOpen = true;
    this.agentResponses = message;
  }
 
  closePopup() {
    this.isKeepAsAlexChatOpen = true;
    this.isPopupOpen = false;
    this.agentResponses = null;
    this.feedbackText = '';
  }
 
  submitFeedback() {
    this.addUserFeedback(this.agentResponses, false, this.feedbackText);
    this.closePopup();
  }

  openIntercomHelp(){
    Intercom('showSpace', 'help');
  }
}
